import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import rocketImage from '../../res/images/rocket.gif';
import './LaunchingRocket.css';
import StarField from '../Mars/components/StarField';

const LaunchingRocket = ({ isLoader = false }) => {
  const [count, setCount] = useState(10);
  const [launchState, setLaunchState] = useState(isLoader ? 'ignition' : 'countdown'); // ignition for loader
  const [starSpeed, setStarSpeed] = useState(isLoader ? 5 : 1);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoader) return; // Skip logic if used as loader

    // Countdown Logic
    if (launchState === 'countdown') {
      if (count > 0) {
        const timer = setTimeout(() => setCount(count - 1), 1000);
        return () => clearTimeout(timer);
      } else {
        // Initiate Ignition
        setLaunchState('ignition');
        setTimeout(() => {
          setLaunchState('launching');
          // Start warping stars after rocket clears screen
          setTimeout(() => {
            setLaunchState('warp');
            setStarSpeed(50); // Hyper speed
          }, 1500);
        }, 1000); // 1s ignition rumble
      }
    } else if (launchState === 'warp') {
      // Navigate after warp effect
      const warpTimer = setTimeout(() => {
        navigate('/mars', { replace: true });
      }, 2000);
      return () => clearTimeout(warpTimer);
    }
  }, [count, launchState, navigate, isLoader]); // Added isLoader dependency

  const handleScreenTap = () => {
    if (isLoader) return; // Disable tap interactions for loader
    if (launchState === 'countdown') {
      setCount(prevCount => Math.max(prevCount - 1, Math.min(prevCount, 2)));
    }
  };

  return (
    <div className={`launching-container ${launchState}`} onClick={handleScreenTap}>
      <StarField speedFactor={starSpeed} />

      {launchState === 'countdown' && (
        <div className={`counter-container ${count <= 3 ? 'warning blink' : ''}`}>
          <span className="count">{count}</span>
          <p className="instruction">Tap to Boost</p>
        </div>
      )}

      {(launchState === 'ignition' || launchState === 'launching' || launchState === 'warp') && (
        <div className="rocket-stage">
          <div className="rocket-wrapper">
            <img className="rocket" src={rocketImage} alt="Rocket" />
            <div className="engine-fire"></div>
          </div>
          <h1 className="launch-status">
            {isLoader
              ? 'ESTABLISHING UPLINK'
              : launchState === 'ignition' ? 'IGNITION' : launchState === 'launching' ? 'LIFTOFF' : 'ENTERING ORBIT'}
          </h1>
        </div>
      )}

      {launchState === 'warp' && <div className="warp-overlay"></div>}
    </div>
  );
};

export default LaunchingRocket;
